import { enrichEventWithFlowExtra } from '@utiles/officialTopupNew/flowExtra';

/**
 * 统一打点入口：断流后的打点自动附加 extra 字段
 * @param {object} params
 * @returns {Promise<void>}
 */
export const pushTrackEvent = (params) => {
  try {
    const event = enrichEventWithFlowExtra(params);
    if (Array.isArray(window?.webstorev35DataLayer)) {
      window.webstorev35DataLayer.push(event);
      return;
    }
    console.error(
      'pushTrackEvent: webstorev35DataLayer is unavailable'
    );
  } catch (error) {
    console.error('pushTrackEvent error', error);
  }
};
